import { withCourseRevisions } from './components/Course/courseRevisions';
import { getUser } from './helper/user';
import React from 'react';
import { Navigate, Route } from 'react-router-dom';
import { ENTRYPOINT } from './config/entrypoint';
import { fetchHydra as baseFetchHydra } from '@api-platform/admin';
import {
  hydraDataProvider as baseHydraDataProvider,
  useIntrospection,
} from '@api-platform/admin';
import { parseHydraDocumentation } from '@api-platform/api-doc-parser';

const getHeaders = () =>
  localStorage.getItem('auth')
    ? {
        Authorization: `Bearer ${localStorage.getItem('auth')}`,
      }
    : {};

const fetchHydra = (url, options = {}) =>
  baseFetchHydra(url, {
    ...options,
    headers: getHeaders,
  });

const RedirectToLogin = () => {
  const introspect = useIntrospection();

  if (localStorage.getItem('auth')) {
    introspect();
    return <></>;
  }

  return <Navigate to="/login" />;
};

// const apiDocumentationParser = () =>
//   parseHydraDocumentation(ENTRYPOINT, {
//     headers: new Headers(getHeaders),
//   }).then(
//     ({ api }) => ({ api }),
//     result => {
//
//       const { api, status } = result;
//       console.log({ status });
//
//       if (status === 401) {
//         return Promise.resolve({
//           api,
//           status,
//           customRoutes: [
//             <Route path="/" render={() => <Navigate to="/login" />} />,
//           ],
//         });
//       }
//
//       return Promise.reject(result);
//     }
//   );

const apiDocumentationParser = async () => {
  try {
    const docs = await parseHydraDocumentation(ENTRYPOINT, {
      headers: getHeaders,
    });
    console.log({ docs });
    return docs;
  } catch (result) {
    console.log({ result });
    const { api, response, status } = result;
    // if (status !== 401 || !response) {
    //   throw result;
    // }

    console.log('catch');
    // Prevent infinite loop if the token is expired
    // window.location.replace('/login');
    localStorage.removeItem('auth');

    if (status === 401) {
      return {
        api,
        response,
        status,
        customRoutes: [<Route key="/" path="/" component={RedirectToLogin} />],
      };
    }

    return Promise.reject(result);
  }
};

export const dataProvider = withCourseRevisions(baseHydraDataProvider({
  entrypoint: ENTRYPOINT,
  httpClient: fetchHydra,
  apiDocumentationParser: apiDocumentationParser,
  useEmbedded: true,
}), getUser);
